export const PORTAL_MENU_ROOT_ID = 'intdev-shared-menu';

export const PORTAL_MENU_DATA_ID = 'intdev-shared-menu-data';

const PORTAL_HEADER_BASE_URL = 'https://shared-menu.vkteam.ru';

export const PORTAL_HEADER_SCRIPT_URL = `${PORTAL_HEADER_BASE_URL}/shared-menu.js`;

export const PORTAL_HEADER_STYLES_URL = `${PORTAL_HEADER_BASE_URL}/shared-menu.css`;

export const PORTAL_HEADER_DATA_URL = `${PORTAL_HEADER_BASE_URL}/menu.json`;
